// extracted by mini-css-extract-plugin
export var standaloneTable = "_1y-0";
export var standaloneTableWithBodyFill = "_1y-1";
export var withExtraHeader = "_1y-2";